import {
  listingLead
} from "./chunk-W7PVTXQP.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/listingLead/listingLead.ts
var listingLead2 = async (listingId, inputContact, apiConfig) => {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, "listingLead");
    const data = await listingLead(listingId, inputContact, _apiConfig);
    return {
      status: "success",
      data
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
};

export {
  listingLead2 as listingLead
};
